/** Resumen · Cobranza · Egresos + Más */
export function buildCondominioNav({ cid, gcMe }) {
  if (!cid) return { primary: [], more: [] };

  const rol =
    gcMe?.membresias?.find((m) => m.condominioId === cid)?.rolGc ||
    (gcMe?.isSuperAdminGc ? 'admin_condominio' : null);

  const isSuper = gcMe?.isSuperAdminGc;
  const isAdmin = isSuper || rol === 'admin_condominio';
  const isTesoreria = rol === 'tesoreria';
  const isComite = rol === 'comite_lectura';
  const isPropietario = rol === 'propietario';
  const canWrite = isSuper || isAdmin || isTesoreria;

  const item = (to, label, end = false) => ({ to, label, end });

  if (isPropietario && !canWrite && !isAdmin) {
    return { primary: [item(`/c/${cid}/portal`, 'Resumen', true)], more: [] };
  }

  const primary = [item(`/c/${cid}`, 'Resumen', true)];

  if (canWrite) {
    primary.push(item(`/c/${cid}/cobranza`, 'Cobranza'));
    primary.push(item(`/c/${cid}/egresos`, 'Egresos'));
  } else if (isComite) {
    primary.push(item(`/c/${cid}/cobranza`, 'Cobranza'));
    primary.push(item(`/c/${cid}/egresos`, 'Egresos'));
  }

  const more = [];
  if (canWrite || isComite) {
    more.push(item(`/c/${cid}/propietarios`, 'Propietarios'));
    more.push(item(`/c/${cid}/cobranza/historial`, 'Historial cobranza'));
    more.push(item(`/c/${cid}/flujo-caja`, 'Caja'));
    more.push(item(`/c/${cid}/informes`, 'Cierre mensual'));
    more.push(item(`/c/${cid}/correos`, 'Correos'));
  }
  more.push(item(`/c/${cid}/portal`, 'Informe comunitario'));
  if (isAdmin) {
    more.push(item(`/c/${cid}/importar`, 'Importar CSV'));
    more.push(item(`/c/${cid}/usuarios`, 'Usuarios'));
    more.push(item(`/c/${cid}/config`, 'Configuración'));
  }

  return { primary, more };
}
